module.exports = __webpack_public_path__ + "static/the-psychedelic-explorers-guide-444fde888ff35b1caa815e9c75d85989.jpg";